import React from "react";

export const mainParagraph = (
  <div className="mainParagraph">
    <p className="content justified">
      Hace poco más de setenta años, Oswaldo Díaz Díaz contó a los niños de mediados del siglo pasado cómo se divertían
      sus abuelos cuando, por allá por 1874, esos viejos eran todavía niños. Hoy, al leer “Diversiones de antaño”, nos
      separa más de un siglo de esa infancia narrada y la conclusión es que, a pesar del tiempo y del desarrollo de las
      tecnologías, los niños siguen jugando a trepar a los árboles, a elevar cometas —aunque ya casi nunca sean de
      papel—, a armar el pesebre y todavía se asustan con las máscaras de los matachines en el carnaval.
    </p>
    <p className="content justified">
      En esta breve narración, en la que es difícil precisar si se dirige a los niños o a los abuelos, Oswaldo Díaz Díaz
      nos cuenta que cuando no existían los automóviles ni el cine, tener un caballo y aprender a montarlo era una de
      las principales diversiones infantiles: “La aventura del primer galope y el susto de la primera caída eran
      emociones compartidas por todos los niños de esos años”.
    </p>
  </div>
);

export const bottomParagraph = (
  <div className="bottomParagraph">
    <p className="content justified">
      Nos muestra, además y sin querer, cómo Colombia pasa de ser un territorio principalmente rural y desescolarizado
      en el que los niños pueden pasar mucho tiempo en el campo o en el solar donde el peor de los peligros es el aljibe
      o “el azote pérfido de las ortigas”, a unas urbes mucho más pobladas en las que hay que “respetar y defender” los
      jardines de las casas.
    </p>
    <p className="content justified">
      Esta narración, de cierto aire melancólico, nos permite hoy poner en paralelo tres momentos de la historia en
      relación a la infancia: el presente, en el que nos preocupan tanto unos niños que solo comen comida empaquetada y
      se la pasan pegados a las pantallas; el momento en el que Díaz Díaz escribió el texto, en 1949, cuando el autor
      nos habla de unos niños “que se ahogan en un cine durante tres horas de cada domingo y que se atiborran la
      imaginación y el estómago de confites y bebidas dulces”, y una infancia idílica, de finales del siglo XIX, y
      concluye:
    </p>
    <p className="content justified">
      “No podemos decir si serían más felices que los de ahora […]. Pero, en todo caso, esas sencillas diversiones de
      entonces les dejaron en la memoria recuerdos imborrables que los han acompañado durante los largos años de su
      vida”.
    </p>
    <p className="content justified">
      Es muy interesante la manera como expone las diversiones de antaño, que incluyen juegos, juguetes artesanales y
      asuntos de la vida familiar, así como las costumbres que aún hoy practicamos, como las procesiones de Semana Santa
      o la Novena de Aguinaldos.
    </p>
    <p className="content justified">
      Y es muy especial, además, porque es un texto que a la luz de hoy une a más de tres generaciones y las vincula a
      través de algo que nos atañe a todos: la infancia y el tiempo libre.
    </p>
  </div>
);

export const sections = <div className="sectionsReview"></div>;
